import {UserService} from '@nuskin/ns-account';
/**
 *
 * @param {*} component
 * @param {*} ProfileService
 * @param {*} CurrencyService
 */
let mounted =(component,ProfileService,CurrencyService)=>{
    let self = component;
    let trackingOrders = self.getTrackingInfo(self.ordernumber);
    trackingOrders.forEach((element, x) => {
        component.trackingInfo.push(element);
    });
    ProfileService.getOrderDetails(self.ordernumber, self.languageLoggedIn, self.marketLoggedIn).then(function (response) {
        let detailsObject = ProfileService.parseOrderDetails(response);
        self.order.orderTotals.orderSubtotal = CurrencyService.format(detailsObject.getSubTotal(), detailsObject.getCountryCode(), 'en');
        self.order.orderTotals.orderShipping = CurrencyService.format(detailsObject.getShippingTotal(), detailsObject.getCountryCode(), 'en');
        self.order.orderTotals.orderTax = CurrencyService.format(detailsObject.getTax(), detailsObject.getCountryCode(), 'en');
        self.order.orderTotals.orderTotal = CurrencyService.format(detailsObject.getGrandTotal(), detailsObject.getCountryCode(), 'en');



        self.order.orderInfo.orderDate = detailsObject.getOrderDate();
        self.order.orderInfo.orderChannel = detailsObject.getOrderChannel();
        self.order.orderInfo.orderStatus = detailsObject.getOrderStatus();

        self.order.orderInfo.addressName = detailsObject.getShippingAddressName();
        self.order.orderInfo.addressLine1 = detailsObject.getShippingAddressLine1();
        self.order.orderInfo.addressLine2 = detailsObject.getShippingAddressLine2();
        self.order.orderInfo.addressLine3 = detailsObject.getShippingAddressLine3();

        self.order.shippingDescription = response.data.SalesOrderResponse.SalesOrderDetail.Shipping.ShippingMethod.Description;
        let payments = response.data.SalesOrderResponse.SalesOrderDetail.Payment[0];
        if (payments !== undefined) {
            self.order.ccInfo.ccType = response.data.SalesOrderResponse.SalesOrderDetail.Payment[0].CreditCard.Type;
        }
        self.order.orderInfo.concatenatedAddress = '';
        if (self.marketLoggedIn === 'JP') {
            let shipTo = response.data.SalesOrderResponse.SalesOrderDetail.Shipping.ShippingParty.filter(e => e.Type === 'SHIP_TO')[0];
            let japanAddress = shipTo.ShippingAddress.Address;
            if (shipTo.ShippingAddress.Name !== '') {
                self.order.orderInfo.concatenatedAddress = self.order.orderInfo.concatenatedAddress + shipTo.ShippingAddress.Name + '<br />';
            }
            self.order.orderInfo.concatenatedAddress = self.order.orderInfo.concatenatedAddress + japanAddress.PostalCode
            + ' ' + self.getJapanStates(japanAddress.Region) + '<br />';
            self.order.orderInfo.concatenatedAddress = self.order.orderInfo.concatenatedAddress + japanAddress.City + '<br />';
            self.order.orderInfo.concatenatedAddress = self.order.orderInfo.concatenatedAddress + japanAddress.District + '<br />';
            self.order.orderInfo.concatenatedAddress = self.order.orderInfo.concatenatedAddress + japanAddress.Street1;

        } else {
            if (self.order.orderInfo.addressName !== '') {
                self.order.orderInfo.concatenatedAddress = self.order.orderInfo.concatenatedAddress + self.order.orderInfo.addressName + '<br />';
            }
            if (self.order.orderInfo.addressLine1 !== '') {
                self.order.orderInfo.concatenatedAddress = self.order.orderInfo.concatenatedAddress + self.order.orderInfo.addressLine1 + '<br />';
            }
            if (self.order.orderInfo.addressLine2 !== '') {
                self.order.orderInfo.concatenatedAddress = self.order.orderInfo.concatenatedAddress + self.order.orderInfo.addressLine2 + '<br />';
            }
            if (self.order.orderInfo.addressLine3 !== '') {
                self.order.orderInfo.concatenatedAddress = self.order.orderInfo.concatenatedAddress + self.order.orderInfo.addressLine3;
            }
        }

        self.canOrderBeReturned(self.order.orderInfo.orderDate);

        let shippingItems = detailsObject.getShippingItems();

        for (let i = 0; i < shippingItems.length; i++) {
            let orderLine = {
                description: shippingItems[i].getDescription(),
                sku: shippingItems[i].getSKU(),
                psv: shippingItems[i].getPsv(),
                price: CurrencyService.format(shippingItems[i].getPrice(), detailsObject.getCountryCode(), 'en'),
                qty: shippingItems[i].getQty(),
                total: CurrencyService.format(shippingItems[i].getTotal(), detailsObject.getCountryCode(), 'en')
            };
            self.order.orderLineItems.push(orderLine);
        }

        self.processing = false;
        document.getElementById('orderHistory').classList.add('router-link-exact-active', 'active');
    });
}
/**
 *
 * @param {*} component
 * @param {*} status
 */
let statusTranslate = (component,status)=>{
    switch (status) {
        case 'BACKORDER':
            return (component.txc.backorder);
        case 'CANCELLED':
            return (component.txc.cancelled);
        case 'COMPLETE':
            return (component.txc.complete);
        case 'DECLINED':
            return (component.txc.declined);
        case 'INCOMPLETE':
            return (component.txc.incomplete);
        case 'PARTIAL_RETURN':
            return (component.txc.partial_return)
        case 'PAYMENT_PENDING':
            return (component.txc.payment_pending);
        case 'PENDING':
            return (component.txc.pending)
        case 'PENDING_RETURN':
            return (component.txc.pending_return);
        case 'PROCESSING':
            return (component.txc.processing);
        case 'RETURNED':
            return (component.txc.returned);
    }
    return 'default';
}
/**
 *
 * @param {*} component
 * @param {*} date
 */
let canOrderBeReturned = (component,date)=>{
    let self = component;
    let d = new Date(date);
    let ts = d.getTime();
    let invoiceDate = self.$moment(ts);
    let today = self.$moment();
    let invoiceAge = (today - invoiceDate) / (1000 * 60 * 60 * 24);

    if (self.marketConfig.enableReturns) {
        if (UserService.getUser().isDistributor()) {
            if (invoiceAge < 365) {
                self.canReturn = true;
            }
        } else {
            if (invoiceAge < 31) {
                self.canReturn = true;
            }
        }
    }
}
/**
 *
 * @param {*} component
 * @param {*} profileUtils
 */
let printOrder = (component,profileUtils)=>{
    window.print();
    profileUtils.publishAnalytics(component.$analytics.category.orders, 'order_detail_view', 'printed')
}
/**
 *
 * @param {*} profileUtils
 * @param {*} trackURL
 */
let showTracking = (profileUtils,trackURL)=>{
    window.open(trackURL, '_blank').focus();
    profileUtils.publishAnalytics('orderDetails', 'TrackingNumberClick', 'click');
}

/**
 *
 * @param {*} component
 * @param {*} profileUtils
 */
let hideDetails = (component,profileUtils)=>{
    profileUtils.publishAnalytics(component.$analytics.category.orders, 'order_detail_view', 'closed');
}

export default {
    hideDetails:hideDetails,
    showTracking:showTracking,
    printOrder:printOrder,
    canOrderBeReturned:canOrderBeReturned,
    statusTranslate:statusTranslate,
    mounted:mounted
};
